import React, { Component } from 'react'
import { View, Text, StyleSheet } from 'react-native'

class MainScene extends Component {
    render() {
    	return (
    		<View style={styles.app}>
    			<View style={styles.appHeader}>
    				<Text style={styles.appTitle}> You seem lost! </Text>
    				<Text style={styles.appTitle}> Please use the link sent to your email. </Text>
    			</View>
    		</View>
    	)
    }
}

const styles = StyleSheet.create({
	app: { flex: 1 },
	appHeader: {
		flex: 1,
		padding: 20,
		alignItems: 'center',
		backgroundColor: '#222',
		justifyContent: 'center'
	},
	appTitle: {
		fontSize: 16,
		color: 'white'
	},
	appIntro: {
		flex: 2,
		fontSize: 30,
		textAlign: 'center'
	}
})

export default MainScene;